module.exports = __webpack_public_path__ + "img/3.7384144b.jpg";